module.exports = __webpack_public_path__ + "img/BE.477e53d6.svg";